const getLastIndex = (arr) => arr[arr.length - 1];

export default getLastIndex;
